/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The IntermodalRoutingParams model module.
 * @module model/IntermodalRoutingParams
 * @version 0.0.2
 */
export class IntermodalRoutingParams {
  /**
   * Constructs a new <code>IntermodalRoutingParams</code>.
   * @alias module:model/IntermodalRoutingParams
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntermodalRoutingParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntermodalRoutingParams} obj Optional instance to populate.
   * @return {module:model/IntermodalRoutingParams} The populated <code>IntermodalRoutingParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntermodalRoutingParams();
      if (data.hasOwnProperty('maxDistanceOverrideRegionalverkehrKm'))
        obj.maxDistanceOverrideRegionalverkehrKm = ApiClient.convertToType(data['maxDistanceOverrideRegionalverkehrKm'], 'Number');
      if (data.hasOwnProperty('maxDistanceOverrideFernverkehrKm'))
        obj.maxDistanceOverrideFernverkehrKm = ApiClient.convertToType(data['maxDistanceOverrideFernverkehrKm'], 'Number');
      if (data.hasOwnProperty('maxDistanceOverrideSuburbanKm'))
        obj.maxDistanceOverrideSuburbanKm = ApiClient.convertToType(data['maxDistanceOverrideSuburbanKm'], 'Number');
      if (data.hasOwnProperty('maxDistanceOverrideNahverkehrKm'))
        obj.maxDistanceOverrideNahverkehrKm = ApiClient.convertToType(data['maxDistanceOverrideNahverkehrKm'], 'Number');
      if (data.hasOwnProperty('maxFootDistanceOepvToOverrideKm'))
        obj.maxFootDistanceOepvToOverrideKm = ApiClient.convertToType(data['maxFootDistanceOepvToOverrideKm'], 'Number');
      if (data.hasOwnProperty('minOverallDistanceForOverrideRegionalverkehrKm'))
        obj.minOverallDistanceForOverrideRegionalverkehrKm = ApiClient.convertToType(data['minOverallDistanceForOverrideRegionalverkehrKm'], 'Number');
      if (data.hasOwnProperty('minOverallDistanceForOverrideFernverkehrKm'))
        obj.minOverallDistanceForOverrideFernverkehrKm = ApiClient.convertToType(data['minOverallDistanceForOverrideFernverkehrKm'], 'Number');
      if (data.hasOwnProperty('minOverallDistanceForOverrideSuburbanKm'))
        obj.minOverallDistanceForOverrideSuburbanKm = ApiClient.convertToType(data['minOverallDistanceForOverrideSuburbanKm'], 'Number');
      if (data.hasOwnProperty('minOverallDistanceForOverrideNahverkehrKm'))
        obj.minOverallDistanceForOverrideNahverkehrKm = ApiClient.convertToType(data['minOverallDistanceForOverrideNahverkehrKm'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} maxDistanceOverrideRegionalverkehrKm
 */
IntermodalRoutingParams.prototype.maxDistanceOverrideRegionalverkehrKm = undefined;

/**
 * @member {Number} maxDistanceOverrideFernverkehrKm
 */
IntermodalRoutingParams.prototype.maxDistanceOverrideFernverkehrKm = undefined;

/**
 * @member {Number} maxDistanceOverrideSuburbanKm
 */
IntermodalRoutingParams.prototype.maxDistanceOverrideSuburbanKm = undefined;

/**
 * @member {Number} maxDistanceOverrideNahverkehrKm
 */
IntermodalRoutingParams.prototype.maxDistanceOverrideNahverkehrKm = undefined;

/**
 * @member {Number} maxFootDistanceOepvToOverrideKm
 */
IntermodalRoutingParams.prototype.maxFootDistanceOepvToOverrideKm = undefined;

/**
 * @member {Number} minOverallDistanceForOverrideRegionalverkehrKm
 */
IntermodalRoutingParams.prototype.minOverallDistanceForOverrideRegionalverkehrKm = undefined;

/**
 * @member {Number} minOverallDistanceForOverrideFernverkehrKm
 */
IntermodalRoutingParams.prototype.minOverallDistanceForOverrideFernverkehrKm = undefined;

/**
 * @member {Number} minOverallDistanceForOverrideSuburbanKm
 */
IntermodalRoutingParams.prototype.minOverallDistanceForOverrideSuburbanKm = undefined;

/**
 * @member {Number} minOverallDistanceForOverrideNahverkehrKm
 */
IntermodalRoutingParams.prototype.minOverallDistanceForOverrideNahverkehrKm = undefined;

